import { RoutePath } from '@wix/app-market-core-types';
import type { IRoute } from '@wix/app-market-core-types';

const hideSaleCollectionsSlugs = [
  'holiday-sale',
  'apps-on-sale',
  'app-benefits',
  'wix-business-solutions',
];

export function showSaleToggle(route: IRoute): boolean {
  switch (route.path) {
    case RoutePath.COLLECTION:
      return !hideSaleCollectionsSlugs.includes(route.payload.slug);
    default:
      return true;
  }
}
